import { Box, SxProps, Theme, Typography } from '@mui/material';

import { Analytics } from '@watershed/analytics/analyticsUtils';
import ArrowLeftIcon from '@watershed/icons/components/ArrowLeft';
import { TestIds } from '@watershed/shared-universal/utils/testUtils';
import Link from '@watershed/ui-core/components/TextLink';
import { Url } from '@watershed/ui-core/types/LinkProps';

const breadcrumbSx: SxProps<Theme> = {
  height: 24,
  marginBottom: 0.5,
  overflow: 'hidden',
  '& svg': { flexShrink: 0 },
};

const breadcrumbLinkSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
};

export interface BreadcrumbProps {
  name: string;
  path?: Url;
  onClick?: () => void;
}

export default function Breadcrumb({
  breadcrumb,
}: {
  breadcrumb: BreadcrumbProps;
}) {
  const linkContent = (
    <Box alignItems="center" display="flex">
      <ArrowLeftIcon marginRight={0.5} />
      <Typography
        variant="h4"
        sx={{ color: (theme) => theme.palette.primary.main }}
      >
        {breadcrumb.name}
      </Typography>
    </Box>
  );
  const link = breadcrumb.path ? (
    <Link
      href={breadcrumb.path}
      sx={breadcrumbLinkSx}
      color="primary"
      underline="none"
      data-testid={TestIds.Breadcrumb}
      onClick={() => {
        Analytics.action('breadcrumb', {
          label: breadcrumb.name,
          link: breadcrumb.path,
        });
      }}
    >
      {linkContent}
    </Link>
  ) : (
    <Link
      sx={breadcrumbLinkSx}
      color="primary"
      underline="none"
      data-testid={TestIds.Breadcrumb}
      onClick={() => {
        if (breadcrumb.onClick) {
          breadcrumb.onClick();
        }
        Analytics.action('breadcrumb', {
          label: breadcrumb.name,
        });
      }}
    >
      {linkContent}
    </Link>
  );

  return <Box sx={breadcrumbSx}>{link}</Box>;
}
